/**
 * Assets en /public del backoffice (CRA + %PUBLIC_URL%).
 * Logos: logo-evenely-black.webp, logo-evenely-white.webp (incl. pantalla de carga).
 */
const pub = typeof process !== "undefined" && process.env && process.env.PUBLIC_URL != null
	? String(process.env.PUBLIC_URL).replace(/\/$/, "")
	: "";

function asset(path) {
	const p = path.startsWith("/") ? path : `/${path}`;
	return pub ? `${pub}${p}` : p;
}

export const EVENELY_LOGO_BLACK_URL = asset("/logo-evenely-black.webp");
export const EVENELY_LOGO_WHITE_URL = asset("/logo-evenely-white.webp");
/** Fallback si falla la carga del webp (mismo public/). */
export const EVENELY_LOGO_BLACK_FALLBACK_URL = asset("/ersaas-logo.png");
export const EVENELY_LOGO_URL = EVENELY_LOGO_BLACK_URL;
export const EVENELY_FAVICON_SVG = asset("/favicon.svg");
export const EVENELY_FAVICON_32 = asset("/favicon32.png");
export const EVENELY_FAVICON_64 = asset("/favicon64.png");

/** onError de <img>: reintenta con otra variante Evenely antes de ocultar. */
export function applyEvenelyLogoFallback(event, variant = "black") {
	const el = event?.currentTarget;
	if (!el) return;
	const step = Number(el.dataset.evenelyFallbackStep || 0);
	if (step === 0) {
		el.dataset.evenelyFallbackStep = "1";
		if (variant === "white") {
			el.src = EVENELY_LOGO_BLACK_URL;
			return;
		}
		el.src = EVENELY_LOGO_BLACK_FALLBACK_URL;
		return;
	}
	if (step === 1 && variant === "white") {
		el.dataset.evenelyFallbackStep = "2";
		el.src = EVENELY_LOGO_BLACK_FALLBACK_URL;
		return;
	}
	el.style.visibility = "hidden";
}
